import { Fragment, ReactNode } from "react";
import ButtonArrow from "../ButtonArrowDown";
import { Styles } from "./styled";
import { getShowDisplaySizeSelector } from "../Header";
import { useLocation } from "react-router-dom";
import { getDisplaySize } from "../DisplaySizeSelector/selector";
import { BUTTON_HEIGHT, FONT_SIZE } from "@lhd/constants";
import { useSelector } from "react-redux";
import { HiOutlineExternalLink } from "react-icons/hi";
import { DISPLAY_SIZES } from "@lhd/types";
import { Tooltip } from "antd";
import ButtonVerticalGoOut from "../ButtonVerticalGoOut";
import ButtonVerticalCollapse from "../ButtonVerticalCollapse";

type QuickViewDetailProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  handleViewDetail?: () => void;
  handleViewEdit?: () => void;
  handleViewMode?: () => void;
  disabledBtnView?: boolean;
  disabledBtnEdit?: boolean;
  hideScrollbar?: boolean;
  hideScroll?: boolean;
  containerHeight?: number | string;
  quickButtonDirection?: "vertical" | "horizontal";
};

const QuickViewDetail = ({
  isOpen,
  onClose,
  children,
  handleViewDetail,
  handleViewEdit,
  handleViewMode,
  disabledBtnView,
  disabledBtnEdit,
  hideScrollbar,
  hideScroll,
  containerHeight,
  quickButtonDirection = "horizontal",
}: QuickViewDetailProps) => {
  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;

  const location: any = useLocation();
  const showDisplaySizeSelector = getShowDisplaySizeSelector(location.pathname);
  if (!isOpen) return <></>;

  const renderVerticalButtons = () => {
    return (
      <Fragment key="vertical">
        <ButtonVerticalCollapse
          onClick={onClose}
          directionArrow="down"
          variant="danger"
          style={{ minHeight: 52 }}
        />
        <ButtonVerticalGoOut
          onClick={handleViewDetail}
          style={{ minHeight: 118 }}
        >
          <div className="vertical-text">全画面で開く</div>
        </ButtonVerticalGoOut>
      </Fragment>
    );
  };

  const renderHorizontalButtons = () => {
    return (
      <Fragment key={"horizontal"}>
        <ButtonArrow
          name="閉じる"
          isClose
          className="btn-close"
          onClick={onClose}
          height={BUTTON_HEIGHT[displaySize ?? DISPLAY_SIZES.SMALL]}
        />
        {handleViewDetail && (
          <button
            className="button-view-detail"
            onClick={handleViewDetail}
            disabled={disabledBtnView}
          >
            閲覧
            <HiOutlineExternalLink
              size={
                displaySize === DISPLAY_SIZES.SMALL
                  ? 14
                  : displaySize === DISPLAY_SIZES.MEDIUM
                  ? 16
                  : 20
              }
            />
          </button>
        )}
        {handleViewEdit && (
          <button
            className="button-view-detail"
            onClick={handleViewEdit}
            disabled={disabledBtnEdit}
          >
            編集
            <HiOutlineExternalLink
              size={
                displaySize === DISPLAY_SIZES.SMALL
                  ? 14
                  : displaySize === DISPLAY_SIZES.MEDIUM
                  ? 16
                  : 20
              }
            />
          </button>
        )}
        {handleViewMode && (
          <button
            className="button-view-detail"
            onClick={handleViewMode}
            disabled={disabledBtnView}
          >
            閲覧
            <HiOutlineExternalLink
              size={
                displaySize === DISPLAY_SIZES.SMALL
                  ? 14
                  : displaySize === DISPLAY_SIZES.MEDIUM
                  ? 16
                  : 20
              }
            />
          </button>
        )}
        <Tooltip title="開発中" color="#6BC77A">
          <button className="button-view-detail notEditable">
            全画面表示
            <HiOutlineExternalLink
              size={
                displaySize === DISPLAY_SIZES.SMALL
                  ? 14
                  : displaySize === DISPLAY_SIZES.MEDIUM
                  ? 16
                  : 20
              }
            />
          </button>
        </Tooltip>
      </Fragment>
    );
  };

  return (
    <Styles
      hideScrollbar={hideScrollbar}
      hideScroll={hideScroll}
      containerHeight={containerHeight}
      showDisplaySizeSelector={showDisplaySizeSelector}
      text_scale={displaySize}
      className={quickButtonDirection}
    >
      {quickButtonDirection === "vertical" && (
        <div className="quickview-header_vertical">
          {renderVerticalButtons()}
        </div>
      )}
      <div className="container-quickview">
        {quickButtonDirection === "horizontal" && (
          <div className="quickview-header">{renderHorizontalButtons()}</div>
        )}
        {children}
      </div>
    </Styles>
  );
};
export default QuickViewDetail;
